import React, {useState, useEffect} from 'react';
import axios from "axios";
import {AgGridReact} from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import './AdminRegistrationTabs.css';
import EditBoatModal from './modals/EditBoatModal';
import EditAnglerModal from './modals/EditAnglerModal';
import DeleteBoatModal from './modals/DeleteBoatModal';
import DeleteAnglerModal from './modals/DeleteAnglerModal';

import { toast } from 'react-toastify';

function AdminRegistrationTabs() {

  const [currentTab, setCurrentTab] = useState(0);
  const [checkinRowData, setCheckinRowData] = useState([]);
  const [anglerRowData, setAnglerRowData] = useState([]);
  const [selectedBoatRow, setSelectedBoatRow] = useState([]);
  const [selectedAnglerRow, setSelectedAnglerRow] = useState([]);
  const [editBoatModal, setEditBoatModal] = useState(false);
  const [deleteBoatModal, setDeleteBoatModal] = useState(false);
  const [editAnglerModal, setEditAnglerModal] = useState(false);
  const [deleteAnglerModal, setDeleteAnglerModal] = useState(false);
  const [numBoats, setNumBoats] = useState();
  const [numCheckedIn, setNumCheckedIn] = useState();
  const [numPaid, setNumPaid] = useState();
  const [amountCollected, setAmountCollected] = useState();
  const [numAnglers, setNumAnglers] = useState();
  const [numOwners, setNumOwners] = useState();
  const [numCaptains, setNumCaptains] = useState();

  const numberSort = (num1, num2) => {
    return num1 - num2;
  }

  const handleTabClick = (e) => {
    setCurrentTab(e.target.id);
  }

  const toggleEditBoatModal = () => {
    setEditBoatModal(!editBoatModal);
  };

  const toggleDeleteBoatModal = () => {
    setDeleteBoatModal(!deleteBoatModal);
  };

  const toggleEditAnglerModal = () => {
    setEditAnglerModal(!editAnglerModal);
  };

  const toggleDeleteAnglerModal = () => {
    setDeleteAnglerModal(!deleteAnglerModal);
  };

  const [checkinColumnDefs, setCheckinColumnDefs] = useState([
    {field: 'id', hide: true},
    {field: 'boatName',  checkboxSelection: true, cellStyle: {textAlign: "left"}},
    {field: 'hasCheckedIn'},
    {field: 'hasPaid'},
    {field: 'amountPaid', comparator: numberSort, cellStyle: {textAlign: "left"}, width: 150},
    {field: 'paymentMethod'},
    {field: 'numWristbands', comparator: numberSort},
    {field: 'dateRegistered'},
    {field: 'teamEmail'},
    {field: 'teamPhoneNumber'},
    {field: 'boatMake'},
    {field: 'boatLength'},
  ]);

  const checkinDefaultColDef = {
    sortable: true,
    filter: true,
    floatingFilter: true,
    resizable: true,
    rowSelection: 'single',
    width: 250,
  }

  const [anglerColumnDefs, setAnglerColumnDefs] = useState([
    {field: 'id', hide: true},
    {field: 'firstName',  checkboxSelection: true, cellStyle: {textAlign: "left"}},
    {field: 'lastName', cellStyle: {textAlign: "left"}},
    {field: 'boatName',  cellStyle: {textAlign: "left"}},
    {field: 'owner'},
    {field: 'captain'},
    {field: 'mate'},
  ]);

  const anglerDefaultColDef = {
    sortable: true,
    filter: true,
    floatingFilter: true,
    resizable: true,
    rowSelection: 'single',
    width: 250,
  }

  const handleBoatRowSelection = (e) => {
    console.log(e.api.getSelectedRows());
    setSelectedBoatRow(e.api.getSelectedRows());
  }

  const handleAnglerRowSelection = (e) => {
    console.log(e.api.getSelectedRows());
    setSelectedAnglerRow(e.api.getSelectedRows());
  }

  const handleEditBoatRow = () => {
    if (selectedBoatRow.length > 0) {
      toggleEditBoatModal();
    } else {
      toast.info("Select a the row you would like to edit first.");
    }
  }

  const handleEditAnglerRow = () => {
    if (selectedAnglerRow.length > 0) {
      toggleEditAnglerModal();
    } else {
      toast.info("Select a the row you would like to edit first.");
    }
  }

  const handleDeleteBoatRow = () => {
    if (selectedBoatRow.length > 0) {
      toggleDeleteBoatModal();
    } else {
      toast.info("Select a the row you would like to delete first.");
    }
  }

  const handleDeleteAnglerRow = () => {
    if (selectedAnglerRow.length > 0) {
      toggleDeleteAnglerModal();
    } else {
      toast.info("Select a the row you would like to delete first.");
    }
  }

  const tabs = [
    {
      id: 0,
      tabTitle: 'Boats (Check-In)',
      content: <div id="myGrid" class="ag-theme-alpine" style={{width: "100%", height: 500}}>
        {editBoatModal && (
          <EditBoatModal selectedRow={selectedBoatRow} toggleModal={toggleEditBoatModal} />
        )}
        {deleteBoatModal && (
          <DeleteBoatModal selectedRow={selectedBoatRow} toggleModal={toggleDeleteBoatModal} />
        )}
        <button className="btn-edit" onClick={handleEditBoatRow}>Edit Selected</button>
        <button className="btn-delete" onClick={handleDeleteBoatRow}>Delete Selected</button>
        <label><strong>Total Boats:</strong> {numBoats}</label>
        <label><strong>Checked-In:</strong> {numCheckedIn}</label>
        <label><strong>Paid:</strong> {numPaid}</label>
        <label><strong>Amount Collected: $</strong> {amountCollected}</label>
        <label></label>
        <br/><br/>
        <AgGridReact
          rowData={checkinRowData}
          columnDefs={checkinColumnDefs}
          animateRows={true}
          defaultColDef={checkinDefaultColDef}
          rowSelection="single"
          onSelectionChanged={handleBoatRowSelection}
        />
      </div>,
    },
    {
      id: 1,
      tabTitle: 'Anglers',
      content: <div id="myGrid" class="ag-theme-alpine" style={{width: "100%", height: 500}}>
        {editAnglerModal && (
          <EditAnglerModal selectedRow={selectedAnglerRow} toggleModal={toggleEditAnglerModal} />
        )}
        {deleteAnglerModal && (
          <DeleteAnglerModal selectedRow={selectedAnglerRow} toggleModal={toggleDeleteAnglerModal} />
        )}
        <button className="btn-edit" onClick={handleEditAnglerRow}>Edit Selected</button>
        <button className="btn-delete" onClick={handleDeleteAnglerRow}>Delete Selected</button>
        <label><strong>Total Anglers:</strong> {numAnglers}</label>
        <label><strong>Owners:</strong> {numOwners}</label>
        <label><strong>Captains:</strong> {numCaptains}</label>
        <label></label>
        <br/><br/>
        <AgGridReact
          rowData={anglerRowData}
          columnDefs={anglerColumnDefs}
          animateRows={true}
          defaultColDef={anglerDefaultColDef}
          rowSelection="single"
          onSelectionChanged={handleAnglerRowSelection}
        />
      </div>,
    },
    {
      id: 2,
      tabTitle: 'Bubble View',
      content: 'FIXME: configurable bubbles go here',
    }
  ]

  useEffect(() => {

    const fetchRegisteredBoatsFromDatabase = async () => {
      let params = {
        method: 'GET',
        url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getAllBoats',
        headers: {'Content-Type': 'application/json'},
      }
      let response = await axios(params);
      let responseList = []
      if (response.data) {
        response.data.forEach((entry) => {
          responseList.push(entry)
        })
      }
      setCheckinRowData(responseList);
      setNumBoats(responseList.length);    // tally number of boats
      
      let checkinCounter = 0;    // tally number checked in
      responseList.forEach(boat => {
        if(boat.hasCheckedIn == "Yes") {
          checkinCounter = checkinCounter + 1;
        } 
      });
      setNumCheckedIn(checkinCounter);

      let paidCounter = 0;    // tally number paid
      responseList.forEach(boat => {
        if(boat.hasPaid == "Yes") {
          paidCounter = paidCounter + 1;
        } 
      });
      setNumPaid(paidCounter);

      let amountCollected = 0;    // tally proceeds collected
      responseList.forEach(boat => {
        amountCollected = +boat.amountPaid + amountCollected;
      });
      setAmountCollected(amountCollected);

    }
    fetchRegisteredBoatsFromDatabase();


    const fetchRegisteredAnglersFromDatabase = async () => {
      let params = {
        method: 'GET',
        url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getAllAnglers',
        headers: {'Content-Type': 'application/json'},
      }
      let response = await axios(params);
      let responseList = []
      if (response.data) {
        response.data.forEach((entry) => {
          responseList.push(entry)
        })
      }
      setAnglerRowData(responseList);
      setNumAnglers(responseList.length);    // tally anglers
      
      let ownerCounter = 0;    // tally owners
      responseList.forEach(angler => {
        if(angler.owner == "Yes") {
          ownerCounter = ownerCounter + 1;
        } 
      });
      setNumOwners(ownerCounter);

      let captainCounter = 0;    // tally captains
      responseList.forEach(angler => {
        if(angler.captain == "Yes") {
          captainCounter = captainCounter + 1;
        } 
      });
      setNumCaptains(captainCounter);

    }
    fetchRegisteredAnglersFromDatabase();

  }, []);

  return (
    <>
    <div className="container">
      <div className="tabs">
        {tabs.map((tab, i) => {
          return <button className={ (currentTab === `${tab.id}`) ? "active" : undefined} key={i} id={tab.id} disabled={currentTab === `${tab.id}`} onClick={handleTabClick} >{tab.tabTitle}</button>
        })}
      </div>
      <div className="content">
        {tabs.map((tab, i) => {
          return <div key={i}>
            {currentTab === `${tab.id}` && 
              <div>
                <p>{tab.content}</p>
              </div>
            }
          </div>
        })}
      </div>
    </div>
  </>
  );
};

export default AdminRegistrationTabs;

